import { useCallback, useEffect, useState } from 'react'
import {
  SOFT_BOOKMARK_CHANGED_EVENT,
  clearSoftBookmark,
  getSoftBookmark,
  setSoftBookmark,
  type SoftBookmark,
  type SoftBookmarkChangedDetail,
} from '@/lib/document-soft-bookmark'

export function useSoftBookmark(documentId: string | null | undefined) {
  const [bookmark, setBookmark] = useState<SoftBookmark | null>(() =>
    getSoftBookmark(documentId)
  )

  useEffect(() => {
    setBookmark(getSoftBookmark(documentId))
  }, [documentId])

  useEffect(() => {
    if (!documentId) return
    const onChange = (event: Event) => {
      const detail = (event as CustomEvent<SoftBookmarkChangedDetail>).detail
      if (detail?.documentId !== documentId) return
      setBookmark(detail.bookmark)
    }
    window.addEventListener(SOFT_BOOKMARK_CHANGED_EVENT, onChange)
    return () => window.removeEventListener(SOFT_BOOKMARK_CHANGED_EVENT, onChange)
  }, [documentId])

  const save = useCallback(
    (next: Omit<SoftBookmark, 'updatedAt'> & { updatedAt?: number }) => {
      if (!documentId) return null
      return setSoftBookmark(documentId, next)
    },
    [documentId]
  )

  const clear = useCallback(() => {
    if (!documentId) return
    clearSoftBookmark(documentId)
  }, [documentId])

  return { bookmark, save, clear }
}
